import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useAppContext, { actions } from "../../../utils/Reducers";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalGradeConfirmPop } from "../popup/GradeConfirmPop";

const Insepection = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    async onSearch(item) {
      await handleMasterSearch(item);
    },
  }));

  const [searchData, setSearchData] = useState([]);

  const [statusW, setStatusW] = useState("");

  const {
    store: { userInfo },
  } = useAppContext();

  const SEARCH_INSPECTION_WAIT_LIST_URL =
    "/mobileweb/inspection/SP_SEARCH_INSPECTION_WAIT_LIST.do";

  const SEARCH_INSPECTION_SEA_WAIT_LIST_URL =
    "/mobileweb/inspection/SP_SEARCH_INSPECTION_SEA_WAIT_LIST.do";

  //AI 검수 로그인
  const INSPECTION_AI_LOGIN_URL = "https://ais.aimos.ai/api/userLogin/login";
  //AI 검수 시작
  const INSPECTION_AI_START_URL =
    "https://ais.aimos.ai/api//inspct/start_inspct";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_INSPECTION_WAIT_LIST_URL,
    },
    { manual: true }
  );

  useEffect(async () => {
    await handleMasterSearch(props.searchParameters);
  }, []);

  const handleMasterSearch = async (item) => {
    const {
      data: { data },
    } = await fetchData({
      url:
        props.bmenuTab === "scrap"
          ? SEARCH_INSPECTION_WAIT_LIST_URL
          : SEARCH_INSPECTION_SEA_WAIT_LIST_URL,
      params: item,
    });
    setSearchData(data);
    setStatusW(data.length);
  };

  const onGradeConfirm = (data) => {
    ModalGradeConfirmPop({
      inspData: data,
      onClose: onClose,
    });
  };

  const onAIInspection = async (event, data) => {
    //AI 검수 로그인
    const {
      data: { accessToken },
    } = await axios({
      method: "POST",
      url: INSPECTION_AI_LOGIN_URL,
      data: {
        emplyrId: "dhsUser",
        pwd: "UGhUgFIDclslRdK",
      },
    }).catch(function (error) {
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        toast.error(
          "AI 검수 로그인 오류 : " + error.response.data.error.message
        );
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        //console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        //console.log("Error", error.message);
      }
      //console.log(error.config);
    });

    console.log(accessToken);
    console.log(data);

    if (accessToken !== "") {
      //AI 검수 시작
      const { data: result } = await axios({
        method: "POST",
        url: INSPECTION_AI_START_URL,
        data: {
          vhcleNo: data.vhclNo,
          inspctReferEsntlKey: data.wssId,
          wtMesureTime: "계근시간",
          fctryCd: "공장코드(SP)",
          scrapZoneCd: "스크랩구역코드(1100A1)",
        },
      }).catch(function (error) {
        if (error.response) {
          // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
          //console.log(error.response.data);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          toast.error(
            "AI 검수시작 오류 : " + error.response.data.error.message
          );
        } else if (error.request) {
          // 요청이 이루어 졌으나 응답을 받지 못했습니다.
          // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
          // Node.js의 http.ClientRequest 인스턴스입니다.
          //console.log(error.request);
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          //console.log("Error", error.message);
        }
        //console.log(error.config);
      });
    }

    console.log(data);
    /*
    if (statusCode === "200") {
      const response = await fetchData({
        url: CHANGE_TRANSO_STATUS_URL,
        data: {
          systemCd: data.systemCd,
          scrapAreaCd: data.scrapAreaCd,
          tmsOdrNo: data.tmsOdrNo,
          transStatusCd: "A",
        },
        method: "POST",
      });
      handleMasterSearch(props.searchParameters);
    }
    */
    event.stopPropagation();
    event.preventDefault();
  };

  //팝업 데이터 가져오기
  const onClose = useCallback(async () => {
    handleMasterSearch(props.searchParameters);
  });

  return (
    <>
      <div id="menu2" className="list">
        {searchData &&
          searchData?.map((data, index) => {
            return (
              <div key={index} onClick={(event) => onGradeConfirm(data)}>
                <div className="ctitle">
                  <button className="carno">{data.vhclNo}</button>
                  {/* <button
                    className="carno ai"
                    onClick={(event) => onAIInspection(event, data)}
                  >
                    {data.vhclNo}
                  </button>
                  <button className="icon_ai">AI</button> */}
                  <div>
                    {data.cameraCnt > 0 ? (
                      <button className="camera"></button>
                    ) : (
                      ""
                    )}
                    {data.warmCnt > 0 ? <button className="al"></button> : ""}
                    {data.outageWght > 0 ? (
                      <div className="nums">-{data.outageWght}</div>
                    ) : (
                      ""
                    )}
                    {data.returnCnt > 0 ? (
                      <button className="close"></button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="cinfo">
                  <div>
                    <h2>
                      {data.itemNm}
                      {data.itemEtcRmksNm !== " "
                        ? "/" + data.itemEtcRmksNm
                        : ""}
                      {data.inspRmks !== " " ? "(" + data.inspRmks + ")" : ""}
                    </h2>
                  </div>
                  <div className="no">
                    <h2>{data.wssId}</h2>
                  </div>
                  <div>
                    <div className="stat calling">호출</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.scrapAreaNm}
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="cinfo">
                  <div>
                    <h2>{data.loadAreaAddr}</h2>
                  </div>
                  <div className="phone">
                    <h2>{data.drivTel}</h2>
                  </div>
                  <div>
                    <div className="stat arrive">입차</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.inptDt}
                      </h2>
                    </div>
                  </div>
                  <div className="com">
                    <h2>
                      {data.vndrNm} / {data.rvndrNm}
                    </h2>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {searchData?.length > 0 ? (
        <div className="res">
          <div>
            <div>검수대기</div>
            <div className="val">
              <div>{statusW}</div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
});

export default Insepection;
